import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=5ce451fe&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=5ce451fe&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce451fe')) {
      api.createRecord('5ce451fe', component.options)
    } else {
      api.reload('5ce451fe', component.options)
    }
    module.hot.accept("./Stats.vue?vue&type=template&id=5ce451fe&", function () {
      api.rerender('5ce451fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/components/Stats.vue"
export default component.exports